import React from "react";
import type { ResponseSelect } from "../../../ManageQuestions/types";

type Props = {
  response: ResponseSelect;
  disabled?: boolean;
  currentSelected?: string[];
  onSelect: (optionId: string) => void;
  reveal?: boolean;
};

const SelectWidget: React.FC<Props> = ({ response, disabled, currentSelected = [], onSelect, reveal }) => {
  const correctIds = new Set(response.options.filter(o => o.is_correct).map(o => o.id));

  return (
    <div className="tap-options">
      {(response.options || []).map((o) => {
        const isSelected = currentSelected.includes(o.id);
        const isCorrect = correctIds.has(o.id);
        const className = [
          "tap-option",
          isSelected ? "is-selected" : "",
          reveal && isCorrect ? "is-correct" : "",
          reveal && isSelected && !isCorrect ? "is-wrong" : "",
        ].join(" ");

        return (
          <button
            key={o.id}
            className={className}
            onClick={() => onSelect(o.id)}
            disabled={disabled}
            aria-pressed={isSelected}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
};

export default SelectWidget;
